// material-ui
import { CardActions } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { Button, Divider, Grid, Typography } from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickAlert from 'components/RedQuickAlert'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import CuratedMediaListForm from 'components/CuratedMediaListForm'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_contentHouse,
  get_selected_contentHouse,
  setSelectedcontentHouse,
} from 'features/contentHouse/contentHouse-slice'
import {
  get_all_curatedMediaList,
  get_selected_curatedMediaList,
  is_curatedMediaList_busy,
  setSelectedcuratedMediaList,
} from 'features/curatedMediaList/curatedMediaList-slice'
import { get_all_media, get_selected_media } from 'features/media/media-slice'
import { get_all_releaseScheduleAction } from 'features/releaseScheduleAction/releaseScheduleAction-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let curatedMediaList_list = useSelector(get_all_curatedMediaList)
  let curatedMediaList_busy = useSelector(is_curatedMediaList_busy)
  let curatedMediaList = useSelector(get_selected_curatedMediaList)
  let media_list = useSelector(get_all_media)
  let media = useSelector(get_selected_media)
  let releaseScheduleAction_list = useSelector(get_all_releaseScheduleAction)
  let contentHouse_list = useSelector(get_all_contentHouse)
  let contentHouse = useSelector(get_selected_contentHouse)
  const [modelChanges, setModelChanges] = React.useState(null)
  const [modelValid, setModelValid] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [modelDirty, setModelDirty] = React.useState(null)
  const [releaseActionArgs, setReleaseActionArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_curated_media_list({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && contentHouse?.id) {
      dispatch(
        autoThunks.load_media({
          contentHouseId: (() => {
            function getContentHouseId(): any {
              return contentHouse?.id
            }

            return getContentHouseId()
          })(),
        }),
      )
    }
  }, [claims?.player, contentHouse?.id])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_curated_media_lists({
          ok: false,
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && curatedMediaList?.id) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_curated_media_list({
          curatedListId: (() => {
            function getModelId(): any {
              return curatedMediaList?.id
            }
            return getModelId()
          })(),
        }),
      )
    }
  }, [claims?.player, curatedMediaList?.id])
  useEffect(() => {
    if (claims?.player && curatedMediaList?.id && releaseActionArgs) {
      dispatch(
        autoThunks.update_release_schedule_actions_for_curated_media_list({
          args: (() => {
            function getReleaseScheduleActionArgs(): any {
              return releaseActionArgs
            }
            return getReleaseScheduleActionArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, curatedMediaList?.id, releaseActionArgs])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_content_houses_for_curated_list({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && curatedMediaList?.id) {
      dispatch(
        autoThunks.get_media_for_curated_media_list({
          curatedListId: (() => {
            function getModelId(): any {
              return curatedMediaList?.id
            }
            return getModelId()
          })(),
        }),
      )
    }
  }, [claims?.player, curatedMediaList?.id])

  function get_current_model() {
    return {
      ...(curatedMediaList || {}),
      ...(modelChanges || {}),
    }
  }

  function modelComponent(): any {
    return (
      <>
        {SC.sharedList(
          (curatedMediaList_list || [])
            .filter((x) => !x.deleted)
            .filter((x) => !x.owner)
            .map((item) => {
              return {
                ...item,
                selected: item?.id === curatedMediaList?.id,
              }
            }),
          SC.sharedListItemBuilder,
          (item) => {
            return {
              name: item?.name || TitleService('Unknown'),
              date: item?.created || item.updated,
              statusColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.dark.main
                  : theme.palette.primary.light,
              getIcon: () => {
                return (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-list-details"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#597e8d"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M13 5h8" />
                    <path d="M13 9h5" />
                    <path d="M13 15h8" />
                    <path d="M13 19h5" />
                    <rect x="3" y="4" width="6" height="6" rx="1" />
                    <rect x="3" y="14" width="6" height="6" rx="1" />
                  </svg>
                )
              },
            }
          },
          (item) => {
            dispatch(setSelectedcuratedMediaList(item?.id))
            setModelChanges({})
            setModelValid(null)
            setModelDirty(null)
            setContextId(uuid())
          },
        )}
      </>
    )
  }

  let output_modelComponent = modelComponent()

  function modelItemForm(storeModelAsync: any, deleteModelAsync: any): any {
    return (
      <>
        <Grid item xs={12} sm={12} md={12}>
          <CuratedMediaListForm
            page={undefined}
            form={get_current_model()}
            onUpdate={(update, valid, dirty) => {
              setModelChanges({
                ...modelChanges,
                ...update,
              })
              setModelValid(valid)
              setModelDirty(dirty)
            }}
            context={{
              id: contextId,
            }}
          />
          <SC.CuratadMediaListMediaReleaseAction
            curatedMediaList={curatedMediaList}
            actions={releaseScheduleAction_list}
            onChange={(args) => {
              setReleaseActionArgs(args)
            }}
          />
          <Grid container spacing={gridSpacing}>
            <Grid item xs={3} sm={3} md={3}>
              <Typography variant="h5" sx={{ m: 0 }}>
                {TitleService('Content Houses')}
              </Typography>
              {SC.sharedList(
                (contentHouse_list || [])
                  .filter((x) => !x.deleted)
                  .map((item) => {
                    return {
                      ...item,
                      selected: item?.id === contentHouse?.id,
                    }
                  }),
                SC.sharedListItemBuilder,
                (item) => {
                  return {
                    name: item?.name || TitleService('Unknown'),
                    date: item?.created || item.updated,
                    selected: item?.id === contentHouse?.id,
                    statusColor:
                      theme.palette.mode === 'dark'
                        ? theme.palette.dark.main
                        : theme.palette.primary.light,
                    getIcon: () => {
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-list-details"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#597e8d"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 5h8" />
                          <path d="M13 9h5" />
                          <path d="M13 15h8" />
                          <path d="M13 19h5" />
                          <rect x="3" y="4" width="6" height="6" rx="1" />
                          <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                      )
                    },
                  }
                },
                (item) => {
                  dispatch(setSelectedcontentHouse(item?.id))
                },
              )}
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <Typography variant="h5" sx={{ m: 0 }}>
                {TitleService('Media')}
              </Typography>
              {SC.sharedList(
                (media_list || [])
                  .filter((x) => !x.deleted)
                  .filter((x) => x.owner === contentHouse?.id)
                  .filter((v) => {
                    return !get_current_model()?.media?.find(
                      (b) => b?.id === v?.id,
                    )
                  })
                  .map((item) => {
                    return {
                      ...item,
                      selected: item?.id === media?.id,
                    }
                  }),
                SC.sharedListItemBuilder,
                (item) => {
                  return {
                    name: item?.name || TitleService('Unknown'),
                    date: item?.created || item.updated,
                    statusColor:
                      theme.palette.mode === 'dark'
                        ? theme.palette.dark.main
                        : theme.palette.primary.light,
                    getIcon: () => {
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-list-details"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#597e8d"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 5h8" />
                          <path d="M13 9h5" />
                          <path d="M13 15h8" />
                          <path d="M13 19h5" />
                          <rect x="3" y="4" width="6" height="6" rx="1" />
                          <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                      )
                    },
                  }
                },
                (item) => {
                  let temp = { ...(modelChanges || {}) }
                  temp.media = temp.media || []
                  if (!temp.media.some((v) => v.id === item.id)) {
                    temp.media.push(item)
                    setModelChanges(temp)
                    setModelDirty(true)
                  }
                },
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <Typography variant="h5" sx={{ m: 0 }}>
                {TitleService('Media Playlist Order')}
              </Typography>
              <rq.RedQuickOrderedList
                value={get_current_model().media || []}
                rowHeight={60}
                createElement={(item) => {
                  let media_item = media_list.find((v) => v.id === item.i)
                  if (media_item)
                    return SC.renderMediaItem(media_item, theme, () => {
                      let temp = get_current_model()
                      temp.media = temp.media || []
                      temp.media = temp.media.filter(
                        (x) => x.id !== media_item.id,
                      )
                      setModelChanges(temp)
                      setModelValid(
                        modelValid !== null ? modelValid && true : true,
                      )
                      setModelDirty(true)
                    })
                  return <></>
                }}
                onChange={(items) => {
                  console.log(items)
                  let temp = get_current_model()
                  temp.media = temp.media || []
                  if (
                    JSON.stringify(temp.media) !==
                    JSON.stringify(items.map((v) => v.id))
                  ) {
                    temp.media = items
                      .sort((a, b) => {
                        return a.y - b.y
                      })
                      .map((v) => {
                        return media_list.find((y) => y.id === v.i)
                      })
                    setModelChanges(temp)
                    setModelValid(
                      modelValid !== null ? modelValid && true : true,
                    )
                    setModelDirty(true)
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
          <Grid container spacing={2}>
            <Grid item>
              <AnimateButton>
                <Button
                  variant="contained"
                  onClick={async () => {
                    dispatch(setSelectedcuratedMediaList(null))
                    setModelChanges({})
                    setModelValid(null)
                    setModelDirty(null)
                  }}
                >
                  {TitleService('New')}
                </Button>
              </AnimateButton>
            </Grid>
            {modelDirty && modelValid && (
              <Grid item>
                <AnimateButton>
                  <Button
                    variant="contained"
                    onClick={async () => {
                      await dispatch(storeModelAsync)
                      setModelChanges({})
                      setModelValid(null)
                      setModelDirty(null)
                      setContextId(uuid())
                    }}
                  >
                    {TitleService('Save')}
                  </Button>
                </AnimateButton>
              </Grid>
            )}
            {curatedMediaList?.id && (
              <Grid item>
                <RedQuickAlert
                  button={
                    <Button
                      variant="contained"
                      sx={{
                        background: theme.palette.error.main,
                        '&:hover': { background: theme.palette.error.dark },
                      }}
                      disabled={curatedMediaList_busy}
                      onClick={async () => {}}
                    >
                      {TitleService('Delete')}
                    </Button>
                  }
                  cancelText={TitleService('No')}
                  affirmativeText={TitleService('Yes')}
                  onOk={async () => {
                    await dispatch(deleteModelAsync)
                    dispatch(setSelectedcuratedMediaList(null))
                    setModelChanges({})
                    setModelValid(null)
                    setModelDirty(null)
                    setContextId(uuid())
                  }}
                  title={TitleService('Are you sure?')}
                  description={TitleService('This is a system wide change.')}
                />
              </Grid>
            )}
          </Grid>
        </CardActions>
      </>
    )
  }

  let output_modelItemForm = modelItemForm(
    autoThunks.storeCuratedMediaListAsync({
      model: (() => {
        function getCuratedMediaList(): any {
          return {
            ...(curatedMediaList || {}),
            ...(modelChanges || {}),
          }
        }
        return getCuratedMediaList()
      })(),
    }),
    autoThunks.deleteCuratedMediaListAsync({
      id: (() => {
        function getModelId(): any {
          return curatedMediaList?.id
        }
        return getModelId()
      })(),
    }),
  )

  function main_card(modelList: any, modelForm: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Busy />
        <Grid item xs={12} xl={3} md={12}>
          <MainCard title={TitleService('Curated Media Lists')}>
            {modelList}
          </MainCard>
        </Grid>
        <Grid item xs={12} xl={9} md={12}>
          <MainCard
            title={curatedMediaList?.name || TitleService('Curated Media List')}
          >
            {modelForm}
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(output_modelComponent, output_modelItemForm)

  return output_main_card
}
